export const recentPosts = [
  {
    "id": 17,
    "site": "swg",
    "title": "Hundred Bullets™ Press Page",
    "category": "game",
    "subCategory": [
      "XBOX",
      "game",
      "press"
    ],
    "description": "Master the great doubt, dodge your own bullets...",
    "fullText": "<p>Tagline: Confront the great doubt, become a zen master, and dodge your own bullets.</p><H3>The Reviews Are In!</H3><blockquote><p>“One of the most cerebral and refreshingly unique takes on the SHMUP formula I’ve played in years.”</p></blockquote> <a href=\"https://completexbox.co.uk/reviews/hundred-bullets-review/\" target=\"_blank\">- Complete Xbox</a><blockquote><p>“A small indie game that is surprising in its atmosphere, its simplicity, and is perfect for small and long sessions! With its efficient handling, the game mixes agility and reflection, and it works very well!”</p></blockquote> <a href=\"https://megaforcemagazine.com/2025/03/test-express-hundred-bullets/\" target=\"_blank\">- MegaForce Magazine</a><H3>The Trailer:</H3><div class=\"responsive-iframe-container\"><iframe src=\"https://www.youtube.com/embed/ZTM6fn7gXw8?rel=0\" allowfullscreen=\"allowfullscreen\" frameborder=\"0\"></iframe></div><p>Would you like to cover the new kind of zen puzzle SHUMP that gamedeveloper.com called <em>\"difficult to write about</em>?\" Hundred Bullets™ may be difficult to write about, but it sure is fun to play. Reach out to me @michaelplzno or email me, michael@silverwaregames.com and I'll hook you up with a free copy of the game!</p><H3>On XBOX and PC</H3><p>Hundred Bullets™ is available on both XBOX and PC. Experience the game on your preferred platform! And you can move your cloud save, achievements, and leaderboard scores with you across platforms!</p><H3>Achievement Guide:</H3><div class=\"responsive-iframe-container\"><iframe src=\"https://www.youtube.com/embed/BjCt5SWOdOU\" allowfullscreen=\"allowfullscreen\" frameborder=\"0\"></iframe></div><H3>Please Review our Game on the XBOX Store:</H3><p>We don't have much marketing power 😱 so it will help if you can write your review on the XBOX Store page. Right now we are over 4.5 out of 5 and we need more reviews to show our average score. If you want to review the game, or make a video, reach out to @michaelplzno on social, or email me at michael@silverwaregames.com</p><p>Check out a little animation of the new icon <a href=\"https://youtube.com/shorts/-a7t3g_6hNc\">right here!</a></p>",
    "authorName": "Michael Silverman",
    "authorLink": "https://michaelplzno.com",
    "authorAvatar": "/assets/images/author.jpg",
    "createdAt": "June 12, 2025",
    "cover": "/assets/images/hundred_bullets_thumb.gif",
    "images": [
      "/assets/hundred_bullets/HundredBullets_Cover_Vertical.png",
      "/assets/hundred_bullets/HundredBullets_Cover_Horizontal.png",
      "/assets/hundred_bullets/SuperHeroArt_NoText.png",
      "/assets/hundred_bullets/TitleHeroArt.png",
      "/assets/hundred_bullets/BoxArt.png",
      "/assets/hundred_bullets/HB_gif1.gif",
      "/assets/hundred_bullets/HB_gif2.gif",
      "/assets/hundred_bullets/BoxArt.png",
      "/assets/hundred_bullets/HB_In_Game_Assets.png",
      "/assets/hundred_bullets/HB_TitleTreatment.png",
      "/assets/hundred_bullets/HB_TitleTreatment_glow_2.png",
      "/assets/hundred_bullets/header.png",
      "/assets/hundred_bullets/Hero-1500px.png",
      "/assets/hundred_bullets/logo.png",
      "/assets/hundred_bullets/LotusHero_inv.png",
      "/assets/hundred_bullets/LotusLogo.png",
      "/assets/hundred_bullets/LotusLogo_Glow.png",
      "/assets/hundred_bullets/BoxArt.png",
      "/assets/hundred_bullets/LotusLogo_inv.png",
      "/assets/hundred_bullets/Splash.png",
      "/assets/hundred_bullets/SS1.png",
      "/assets/hundred_bullets/SS2.png",
      "/assets/hundred_bullets/SS3.png",
      "/assets/hundred_bullets/SS4.png"
    ],
    "ctaButtons": [
      {
        "platformLogo": "/assets/images/xbox-app.png",
        "titleText": "Buy Hundred Bullets on XBOX Now",
        "priceTag": "$9.99",
        "appIcon": "/assets/images/hundredbullets-icon.png",
        "linkTo": "https://www.xbox.com/en-us/games/store/hundred-bullets/9p7bw4gn1lr0"
      },
      {
        "platformLogo": "/assets/images/windows-logo.png",
        "titleText": "Buy Hundred Bullets on PC Windows Store Now",
        "priceTag": "$9.99",
        "appIcon": "/assets/images/hundredbullets-icon.png",
        "linkTo": "https://apps.microsoft.com/detail/9P7BW4GN1LR0"
      }
    ]
  },
  {
    "id": 26,
    "site": "cda",
    "title": "Week of AI Gallery",
    "category": "doodle",
    "subCategory": [
      "coffee",
      "sketches",
      "AI"
    ],
    "description": "New AI is turning my work into masterpieces...",
    "fullText": "<p>I've made a lot of drawings, around 2,000 of them. But every time I put them into the AI and say \"Make my art a Masterpiece\" it has never told me that my art is already a masterpiece.</p> <p>But it's a lot of fun to see what AI does. Sometimes I tell the machine to focus on one part of the composition. Sometimes it makes something more like a rembrant, sometimes picaso, sometimes it does a less well known style.</p><p>I'm thinking of making a site that will be a gallery of the very best AI pieces if I can get some other artists to join up in this adventure. Just email me at CoffeeDoodleArt@gmail.com if you want to be a part of this epic journey and once we get a bunch of people interested we can start a new site for our work!</p>",
    "authorName": "Lily and Michael",
    "authorAvatar": "/assets/images/lilymichael2.png",
    "createdAt": "May 10, 2025",
    "cover": "/assets/images/CDA26-thumb.png",
    "duration": "18 pieces",
    "images": [
      "/assets/cda/25.05.10/01.M.05.10.25%20Floating%20Cactus.png",
      "/assets/cda/25.05.10/02.M.05.10.25%20Bird%20Fish%20and%20Robot.png",
      "/assets/cda/25.05.10/03.M.05.10.25%20Demon.png",
      "/assets/cda/25.05.10/04.M.05.10.25%20Kronos.png",
      "/assets/cda/25.05.10/05.M.05.10.25%20Mind%20Games.png",
      "/assets/cda/25.05.10/06.M.05.10.25%20Nigel.png",
      "/assets/cda/25.05.10/07.M.05.10.25%20Puzzle%20Snake.png",
      "/assets/cda/25.05.10/08.M.05.10.25%20Still%20On%20the%20Table.png",
      "/assets/cda/25.05.10/09.M.05.10.25%20Swim%20Meet.png",
      "/assets/cda/25.05.10/10.M.05.10.25%20Tourist.png",
      "/assets/cda/25.05.10/11.M.05.10.25%20Deadpool.png",
      "/assets/cda/25.05.10/12.M.05.10.25%20Moon%20Roof.png",
      "/assets/cda/25.05.10/13.M.05.10.25%20Made%20of%20Bricks.jpg",
      "/assets/cda/25.05.10/14.M.05.10.25%20Melted.png",
      "/assets/cda/25.05.10/15.M.05.10.25%20Holy%20Gruboli.jpg",
      "/assets/cda/25.05.10/16.M.05.10.25%20Noise.jpg",
      "/assets/cda/25.05.10/17.M.05.10.25%20Brainzilla.png",
      "/assets/cda/25.05.10/18.M.05.10.25%20Grenjarnia%20.png"
    ],
    "ctaButtons": [
      {
        "platformLogo": "/assets/images/cta-email.png",
        "titleText": "Email Us To Buy a Print",
        "priceTag": "$30 Per Print",
        "appIcon": "/assets/images/CDALogo.png",
        "linkTo": "mailto:coffeedoodleart@gmail.com?subject=I'd like to buy one of your prints!"
      }
    ]
  },
  {
    "id": 13,
    "site": "matchyverse",
    "title": "Rewriting the Universe",
    "category": "design",
    "subCategory": [
      "game",
      "matchy star",
      "gamedev"
    ],
    "description": "Big changes are coming to the Matchyverse™...",
    "fullText": "<p>We've been reworking EVERYTHING about Matchy Star. Since we are basically in stealth mode, there is no reason not to make this game the most fun matching game ever made.</p><p>Some of the stuff we've been working on.</p><ul><li>Items are unique and interesting.</li><li>Chill ballast system instead of making the ships move fast and stress you out.</li><li>Arc Chart screen where you can rotate the Alpha Galaxy to select your course.</li><li>Stats and unlock progress.</li><li>More levels and improved progression curve.</li></ul><p>Also we are defining the universe more, and creating some AI animations for various characters and locations in the Universe!</p>",
    "authorName": "Michael Silverman",
    "authorLink": "https://michaelplzno.com",
    "authorAvatar": "/assets/images/matchyverse-signature-michael.webp",
    "createdAt": "April 23, 2025",
    "cover": "/assets/images/Zazz_Lair_Thumb.gif",
    "ctaButtons": [
      {
        "platformLogo": "/assets/images/discord.png",
        "titleText": "Join Our Discord Chat",
        "priceTag": "Learn More!",
        "appIcon": "/assets/images/MatchyOGIcon.png",
        "linkTo": "https://discord.silverwaregames.com"
      }
    ]
  },
  {
    "id": 7,
    "site": "plzno",
    "title": "Compsci Guy: 3 Body",
    "category": "youtube",
    "subCategory": [
      "math",
      "compsi",
      "netflix"
    ],
    "description": "Analasys of popular netflix show 3 body problem...",
    "fullText": "<a href=\"https://www.youtube.com/watch?v=BbPE4R6KG_A\"> Watch on youtube! </a>",
    "authorName": "michaelplzno",
    "authorAvatar": "/assets/images/plzno.jpg",
    "createdAt": "Jun 23, 2024",
    "cover": "/assets/images/3BodyThumb.gif",
    "link": "https://www.youtube.com/watch?v=BbPE4R6KG_A",
    "duration": "6min"
  }
];